<template>
    <div class="contain">
      <!-- <h3>Comics:</h3> -->
      <div class="foto1">
        <img class="rounded-t-lg" :src="url1" alt=""/>
      </div>
      <div class="foto2">
        <img class="rounded-t-lg" :src="url2" alt=""/>
      </div>
      <div class="foto3">
        <img class="rounded-t-lg" :src="url3" alt=""/>
      </div>
       
        
    </div>
</template>
<script>
import { public_key } from "../marvel";
import axios from "axios";

export default {
    components: {  },
    name: 'Comics',
    props: ['name'],
    data() {
        return {
            characterId: this.name,
            comic: "",
            url1:"",
            url2:"",
            url3:"",
            first:"",
            seccond:"",
            third:"",
            size:"standard_large.jpg",
        }
    },
    mounted() {
      this.getComicsforId()
    },
    methods: {
        async getComicsforId() {
    
           let id = this.characterId

            // let name = this.state.name
            console.log(id);
             await axios
              .get(
                `https://gateway.marvel.com/v1/public/characters/${id}/comics?apikey=${public_key}`
                
              )
              .then((result) => {
                this.comic = result.data.data.results
                this.first = this.comic[10]
                 console.log(result)
                this.seccond = this.comic[11]
                this.third = this.comic[12]

                this.url1 = this.first.images[0].path + "/" + this.size
                this.url2 = this.seccond.images[0].path + "/" + this.size
                this.url3 = this.third.images[0].path + "/" + this.size
               
              })
              .catch((error) => {
                console.log(error);
              });
        
              
          },
        
    },


}
</script>
<style  scoped>
.contain{
  display: flex;
  flex-direction: row;
}
.foto3 { grid-area: foto3; }
.foto2 { grid-area: foto2; }
.foto1 { grid-area: foto1; }


</style>

